import { render } from "./empty-comp.vue?vue&type=template&id=764911ff&scoped=true"
import script from "./empty-comp.vue?vue&type=script&lang=js"
export * from "./empty-comp.vue?vue&type=script&lang=js"

import "./empty-comp.vue?vue&type=style&index=0&id=764911ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764911ff"]])

export default __exports__